/**
 * Svelte mount point, plus the service-worker registration that makes the app
 * installable ("Frontend: Svelte + Vite, built as an installable PWA").
 *
 * The application shell and every screen live in ./App.svelte and the
 * components it imports — owned by the frontend agent, not by the scaffold.
 */
import { mount } from 'svelte';
import App from './App.svelte';

const target = document.getElementById('app');

if (!target) {
  throw new Error('Mount target #app is missing from index.html');
}

const app = mount(App, { target });

/*
 * Registered after load so it never competes with the first render on site
 * WiFi, and never on the dev server, where a cached shell would hide the
 * change you just made. public/sw.js caches the app shell ONLY — it does not
 * touch /api, so no record is ever served from a cache.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // An unregistered worker costs the install prompt, not the app.
    });
  });
}

export default app;
